import React from 'react';
import ReactDOM from 'react-dom';
import TextField from 'material-ui/TextField';


import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Grading from './grading.js';
import './App.css';

class Aa1Info extends React.Component{


  //handles user inputs of their attempt at recalling the amino acids


  handleUserInputAlanine(e){
   this.setState({
     alanine: e.target.value,
   });

 }

 handleUserInputArginine(e){
  this.setState({
    arginine: e.target.value,
  });

}

  handleUserInputAsparagine(e){
   this.setState({
     asparagine: e.target.value,
   });

 }

   handleUserInputAspartate(e){
    this.setState({
      aspartate: e.target.value,
    });

  }

 handleUserInputCystine(e){
  this.setState({
    cystine: e.target.value,
  });

}



handleUserInputGlutamate(e){
 this.setState({
   glutamate: e.target.value,
 });

}

handleUserInputGlutamine(e){
this.setState({
  glutamine: e.target.value,
});

}

handleUserInputGlycine(e){
 this.setState({
   glycine: e.target.value,
 });

}

 handleUserInputHistidine(e){
  this.setState({
    histidine: e.target.value,
  });

}

handleUserInputIsoleucine(e){
this.setState({
  isoleucine: e.target.value,
});

}

handleUserInputLeucine(e){
this.setState({
  leucine: e.target.value,
});

}




handleUserInputLysine(e){
 this.setState({
   lysine: e.target.value,
 });

}

handleUserInputMethionine(e){
this.setState({
  methionine: e.target.value,
});

}

handleUserInputPhenylalanine(e){
 this.setState({
   phenylalanine: e.target.value,
 });

}

 handleUserInputProline(e){
  this.setState({
    proline: e.target.value,
  });

}

handleUserInputSerine(e){
this.setState({
  serine: e.target.value,
});

}



handleUserInputThreonine(e){
this.setState({
 threonine: e.target.value,
});

}

handleUserInputTryptophan(e){
this.setState({
tryptophan: e.target.value,
});

}

handleUserInputTyrosine(e){
this.setState({
 tyrosine: e.target.value,
});

}

handleUserInputValine(e){
this.setState({
  valine: e.target.value,
});

}

//initializing the textFields

 constructor(props){
   super(props);
   this.state = {alanine: '',
   arginine: '',
   asparagine: '',
   aspartate: '',
   cystine: '',
   glutamate: '',
   glutamine: '',
   glycine: '',
   histidine: '',
   isoleucine: '',
   leucine: '',
   lysine: '',
   methionine: '',
   phenylalanine: '',
   proline: '',
   serine: '',
   threonine: '',
   tryptophan: '',
   tyrosine: '',
    valine: ''
    };

    //following the requirement of binding handleInputs
   this.handleUserInputAlanine = this.handleUserInputAlanine.bind(this);
   this.handleUserInputArginine = this.handleUserInputArginine.bind(this);
   this.handleUserInputAsparagine = this.handleUserInputAsparagine.bind(this);
   this.handleUserInputAspartate = this.handleUserInputAspartate.bind(this);
   this.handleUserInputCystine = this.handleUserInputCystine.bind(this);
   this.handleUserInputGlutamate = this.handleUserInputGlutamate.bind(this);
   this.handleUserInputGlutamine = this.handleUserInputGlutamine.bind(this);
   this.handleUserInputGlycine = this.handleUserInputGlycine.bind(this);
   this.handleUserInputHistidine = this.handleUserInputHistidine.bind(this);
   this.handleUserInputIsoleucine = this.handleUserInputIsoleucine.bind(this);
   this.handleUserInputLeucine = this.handleUserInputLeucine.bind(this);
   this.handleUserInputLysine = this.handleUserInputLysine.bind(this);
   this.handleUserInputMethionine = this.handleUserInputMethionine.bind(this);
   this.handleUserInputPhenylalanine = this.handleUserInputPhenylalanine.bind(this);
   this.handleUserInputProline = this.handleUserInputProline.bind(this);
   this.handleUserInputSerine = this.handleUserInputSerine.bind(this);
   this.handleUserInputThreonine = this.handleUserInputThreonine.bind(this);
   this.handleUserInputTryptophan = this.handleUserInputTryptophan.bind(this);
   this.handleUserInputTyrosine = this.handleUserInputTyrosine.bind(this);
   this.handleUserInputValine = this.handleUserInputValine.bind(this);

   //the textFields
   var shuffle = require('shuffle-array');
   this.state = {};
   this.Aa1Array = shuffle([
     //All the text fields
          <div> <div style = {{color: '#00B8D4'}}> A </div> <TextField  onChange = {this.handleUserInputAlanine} value = {this.state.alanine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> R </div> <TextField  onChange = {this.handleUserInputArginine} value = {this.state.arginine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> N </div> <TextField  onChange = {this.handleUserInputAsparagine} value = {this.state.asparagine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> D </div> <TextField  onChange = {this.handleUserInputAspartate} value = {this.state.aspartate}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> C </div> <TextField  onChange = {this.handleUserInputCystine} value = {this.state.cystine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> E </div> <TextField  onChange = {this.handleUserInputGlutamate} value = {this.state.glutamate}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> Q </div> <TextField  onChange = {this.handleUserInputGlutamine} value = {this.state.glutamine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> G </div> <TextField  onChange = {this.handleUserInputGlycine} value = {this.state.glycine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> H </div> <TextField  onChange = {this.handleUserInputHistidine} value = {this.state.histidine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> I </div> <TextField  onChange = {this.handleUserInputIsoleucine} value = {this.state.isoleucine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> L </div> <TextField  onChange = {this.handleUserInputLeucine} value = {this.state.leucine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> K </div> <TextField  onChange = {this.handleUserInputLysine} value = {this.state.lysine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> M </div> <TextField  onChange = {this.handleUserInputMethionine} value = {this.state.methionine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> F </div> <TextField  onChange = {this.handleUserInputPhenylalanine} value = {this.state.phenylalanine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> P </div> <TextField  onChange = {this.handleUserInputProline} value = {this.state.proline}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> S </div> <TextField  onChange = {this.handleUserInputSerine} value = {this.state.serine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> T </div> <TextField  onChange = {this.handleUserInputThreonine} value = {this.state.threonine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> W </div> <TextField  onChange = {this.handleUserInputTryptophan} value = {this.state.tryptophan}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> Y </div> <TextField  onChange = {this.handleUserInputTyrosine} value = {this.state.tyrosine}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> V </div> <TextField  onChange = {this.handleUserInputValine} value = {this.state.valine}/> </div>
   ]);



 }



  render(){
    let textFields = this.Aa1Array.map(Aa1 => <ul> {Aa1} </ul>);

    return(
      <MuiThemeProvider>
      <div style = {{paddingTop: 20}}>

       {textFields}
       <Grading alanine = {this.state.alanine} arginine = {this.state.arginine}
          asparagine = {this.state.asparagine} aspartate = {this.state.aspartate}
          cystine = {this.state.cystine} glutamate = {this.state.glutamate}
          glutamine = {this.state.glutamine} glycine = {this.state.glycine}
          histidine = {this.state.histidine} isoleucine = {this.state.isoleucine}
          leucine = {this.state.leucine} lysine = {this.state.lysine}
          methionine = {this.state.methionine} phenylalanine = {this.state.phenylalanine}
          proline = {this.state.proline} serine = {this.state.serine}
          threonine = {this.state.threonine} tryptophan = {this.state.tryptophan}
          tyrosine = {this.state.tyrosine} valine = {this.state.valine}/>

      </div>

      </MuiThemeProvider>
    );

  }

}

export default Aa1Info;



// WEBPACK FOOTER //
// ./src/Aa1Info.js